import { Component } from '@angular/core';
import { ToolsProvider } from '../../providers/tools/tools';
import { AppVersion } from '@ionic-native/app-version';

@Component({
  selector: 'review-modal',
  templateUrl: 'review-modal.html',
})
export class ReviewModalComponent {
  text: string;

  versionNumber = null;

  constructor(public tools: ToolsProvider, public appVersion: AppVersion) {
    this.appVersion.getVersionNumber().then(
      versionNumber => {
        this.versionNumber = versionNumber;
      },
      error => {
        console.log(error);
      }
    );
  }

  openModal(modalId: string) {
    this.trackModalEvent(modalId);
    let modal = document.getElementById(modalId);
    modal.classList.remove('hidden');
    modal.classList.add('show');
  }

  closeModal(modalId: string) {
    if (!modalId) {
      this.tools.emit('close-review-modal');
    } else {
      let modal = document.getElementById(modalId);
      modal.classList.remove('show');
      modal.classList.add('hidden');
    }
  }

  trackModalEvent(modalId: string) {
    switch (modalId) {
      case 'user-review-modal':
        this.tools.logAnalyticsEvent('track-custom', 'leaveReview');
        break;
      case 'user-feedback-modal-positive':
        this.tools.logAnalyticsEvent('track-custom', 'leaveReview-yes');
        break;
      case 'user-feedback-modal-negative':
        this.tools.logAnalyticsEvent('track-custom', 'leaveReview-notReally');
      default:
        break;
    }
  }

  trackModalClickEvent(action: string) {
    this.tools.logAnalyticsEvent('track-custom', action);
  }

  openExternalReview() {
    this.tools.requestManualReview();
  }

  openMailFeedback() {
    let s = `App ${this.versionNumber ? this.versionNumber + ' ' : ''}Feedback`;
    let b = 'What feedback do you have for the CDLLife App?';

    window.open(
      `mailto:feedback@cdllife.zendesk.com?subject=${s || ''}&body=${b || ''}`,
      '_system'
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/review-modal/review-modal.ts